// extracted by mini-css-extract-plugin
export default {"header":"style_header__Rn-dv","header__title":"style_header__title__qm0Z+"};